import { COMMON_DOCUMENTS } from './documents';
function coDocument(type, label, pattern, ripsCode, example, normalise = 'digits') {
    return {
        type,
        labelKey: `identity.${type}`,
        label,
        pattern,
        normalise,
        checksum: 'none',
        onChecksumFail: 'warn',
        onPatternFail: type === 'co_cc' ? 'refuse' : 'warn',
        ...(type === 'co_cc' ? { impliesNationality: 'CO' } : {}),
        ripsCode,
        example,
    };
}
export const CO = {
    code: 'CO',
    name: 'Colombia',
    profileVersion: 1,
    readiness: 'preview',
    timezone: 'America/Bogota',
    weekend: [6, 0],
    firstDayOfWeek: 1,
    currency: { code: 'COP', displayFractionDigits: 0, roundToWholeUnits: true },
    subdivisions: [],
    branchSubdivision: 'none',
    locales: {
        ui: ['es', 'en'],
        defaultUi: 'es',
        documentSecondary: null,
        secondaryOnTaxDocuments: 'off',
        secondaryOnClinicalDocuments: 'off',
        formatting: { es: 'es-CO', en: 'en-GB' },
    },
    phone: { callingCode: '57', trunkPrefix: null, nationalLengths: [10], mobilePattern: '^3\\d{9}$', example: '3001234567' },
    names: {
        parts: ['first', 'middle', 'last', 'secondLast'],
        labels: { middle: 'Otros nombres', last: 'Primer apellido', secondLast: 'Segundo apellido' },
        askLocalName: false,
    },
    identity: {
        documents: [
            coDocument('co_cc', 'Cédula de ciudadanía', '^\\d{6,10}$', 'CC', '1020304050'),
            coDocument('co_ce', 'Cédula de extranjería', '^[0-9A-Z]{3,15}$', 'CE', '123456', 'upper_alnum'),
            coDocument('co_ti', 'Tarjeta de identidad', '^\\d{10,11}$', 'TI', '1020304050'),
            coDocument('co_rc', 'Registro civil', '^[0-9A-Z]{8,11}$', 'RC', '1020304050', 'upper_alnum'),
            coDocument('co_ppt', 'Permiso por protección temporal', '^[0-9A-Z]{3,16}$', 'PT', '1234567', 'upper_alnum'),
            coDocument('co_cn', 'Certificado de nacido vivo', '^\\d{9}$', 'CN', '123456789'),
            ...COMMON_DOCUMENTS,
        ],
        defaultType: 'co_cc',
        autoDetect: false,
        capture: { hospital: 'required', lab: 'required', pharmacy: 'optional' },
        askNationality: false,
        dobCalendars: ['gregory'],
    },
    practitionerRegistries: [{ code: 'RETHUS', label: 'RETHUS registration' }],
    tax: [
        {
            code: 'co_iva',
            effectiveFrom: '1983-01-01',
            registration: { labelKey: 'tax.co_nit', label: 'NIT', pattern: '^\\d{6,15}-?\\d$', checksum: 'co_nit_dv', onFail: 'refuse' },
            companyRegistrationLabelKey: null,
            companyRegistrationLabel: null,
            standardRatePct: 19,
            serviceDefaultCategory: 'out_of_scope',
            productDefaultCategory: 'standard',
            qr: null,
            citizenRelief: null,
        },
    ],
    eInvoicing: { scheme: 'dian_fev_rips', mandatory: 'now', fromDate: null, appliesTo: ['hospital', 'lab', 'pharmacy'] },
    addOns: [{ code: 'dian_fev', built: false }],
    feeSplittingDefault: true,
};
//# sourceMappingURL=co.js.map